/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const REVIEWS_TEASER_COMPONENT_KEY = 'ReviewsTeaser'

export const REVIEWS_TEASER_DEFAULT_COUNT = '40'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const REVIEWS_TEASER_DEFAULT_CONFIG = {
  carouselConfig: {
    autoplay: false,
    responsive: {
      mobile: {
        perPage: 1.2,
        variableWidth: false,
        hasButtons: false
      },
      desktop: {
        perPage: 4,
        variableWidth: false
      }
    }
  },
  reviewsPeriod: '30days'
}
